import styles from '~/modules/Shared/Infrastructure/Components/ProgressBar.module.scss'
import { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'

interface Props {
  progress: number
}

export const ProgressBar: FC<Props> = ({ progress }) => {
  const size = 20
  const trackWidth = 2
  const trackColor = '#7c7c7c'
  const indicatorWidth = 2
  const indicatorColor = '#02D93E'
  const indicatorCap = 'round'

  const center = size / 2
  const radius = center - (trackWidth > indicatorWidth ? trackWidth : indicatorWidth)
  const dashArray = 2 * Math.PI * radius
  const dashOffset = dashArray * ((100 - progress) / 100)

  let label = null

  if (progress >= 100) {
    label = (<>
      <FontAwesomeIcon
        className={ styles.svgPi__label }
        icon={ faCheck }
      />
    </>)
  }

  return (
    <div
      className={ styles.svgPi__wrapper }
      style={ { width: size, height: size } }
    >
      <svg
        className={ styles.svgPi }
        style={ { width: size, height: size } }
      >
        <circle
          cx={ center }
          cy={ center }
          fill="transparent"
          r={ radius }
          stroke={ trackColor }
          strokeWidth={ trackWidth }
        />
        <circle
          cx={ center }
          cy={ center }
          fill="transparent"
          r={ radius }
          stroke={ indicatorColor }
          strokeWidth={ indicatorWidth }
          strokeDasharray={ dashArray }
          strokeDashoffset={ dashOffset }
          strokeLinecap={ indicatorCap }
        />
      </svg>
      { label }
    </div>
  )
}
